import DEFAULT from "assets/icon/check/icon_check.svg";
import WHITE from "assets/icon/check/icon_check_white.svg";
import DEFAULT_WHITE from "assets/icon/check/icon_check_default.svg";
import GRAY from "assets/icon/check/icon_check_gray.svg";
import BLUE from "assets/icon/check/icon_check_blue.svg";

export const ICON_CHECK = {
  DEFAULT,
  DEFAULT_WHITE,
  WHITE,
  GRAY,
  BLUE,
};
